import { render, staticRenderFns } from "./StockOpnamePrintDetails_Items.vue?vue&type=template&id=da38e314&"
import script from "./StockOpnamePrintDetails_Items.vue?vue&type=script&lang=js&"
export * from "./StockOpnamePrintDetails_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports